import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

interface IProps {
  code: any;
}

export default class Tawkto extends PureComponent<IProps> {
  componentDidMount() {
    if (!(window as any).Tawk_API) {
      const script = document.createElement('script');

      script.innerHTML = `
      var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
          var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
          s1.async=true;
          s1.src='https://embed.tawk.to/${this.props.code}${this.props.code.includes('/') ? '' : '/default'}';
          s1.charset='UTF-8';
          s1.setAttribute('crossorigin','*');
          s0.parentNode.insertBefore(s1,s0);
      })();
    `;
      // eslint-disable-next-line react/no-find-dom-node
      ReactDOM.findDOMNode(this).appendChild(script);
    }
  }

  componentWillUnmount() {
    if (!!(window as any).Tawk_API && (window as any).Tawk_API.hideWidget) {
      (window as any).Tawk_API.hideWidget();
    }
  }

  render() {
    if (!!(window as any).Tawk_API && (window as any).Tawk_API.showWidget) {
      (window as any).Tawk_API.showWidget();
    }

    return <span></span>;
  }
}
